// extracted by mini-css-extract-plugin
export default {"tooltip":"yP-z","arrow":"zP-z"};